import { Content, Layout } from 'apps/dashboard/shared/scripts/components';
import { useSignatures } from 'apps/shared/scripts/graphql';

import { LoadingSignatures, SignaturesList } from '../../components';

import messages from './messages.json';

const SIGNATURE_FETCH_LIMIT = 10;

const SignedContainer = () => {
  const { signatures, isLoading, fetchMore, cursor, hasNextPage } =
    useSignatures({
      fetchPolicy: 'cache-and-network',
      variables: {
        first: SIGNATURE_FETCH_LIMIT,
      },
    });

  return (
    <Layout>
      <Content title={messages.signedTitle}>
        {isLoading ? (
          <LoadingSignatures />
        ) : (
          <SignaturesList
            signatures={signatures}
            cursor={cursor}
            fetchMore={fetchMore}
            hasNextPage={hasNextPage}
          />
        )}
      </Content>
    </Layout>
  );
};

SignedContainer.displayName = 'SignedContainer';

export default SignedContainer;
